import MicrolearningChoice from './container'
export default MicrolearningChoice
